import {
  useMealType,
  useBreakduration,
  useShiftTimeRange,
  meal,
  useBreaks
} from '@spa/scenes/Plannings/Forms/validations/ShiftForm/shiftFormValidations'
import * as yup from 'yup'

export const useShiftSchemaValidations = () => {
  const meal_type = useMealType()
  const breakduration = useBreakduration()
  const shift_time_range = useShiftTimeRange()
  const breaks = useBreaks()

  return yup.object().shape({
    meal,
    meal_type,
    breakduration,
    shift_time_range,
    breaks
  })
}
